export default "__VITE_ASSET__BneCyyVK__"